// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"5963":"f294d13b249f09e3","19351":"c1f7de0082641d15","19483":"ce90a3df4e198a80","53348":"bdb3fdcc4e450981","59127":"232328e7eed67b47"}[chunkId] + ".js";
};